/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取巡演详情页信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  tourId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.TourDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/tour/${tourId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
